export type Language = "es" | "en";

export const t = {
  es: {
    nav: {
      home: "Inicio",
      about: "Nosotros",
      services: "Servicios",
      portfolio: "Portafolio",
      pricing: "Precios",
      contact: "Contacto",
      startProject: "Iniciar Proyecto",
    },
    hero: {
      title1: "Impulsamos tu negocio",
      titleExtra: "al mundo digital",
      title2: "creando páginas web",
      desc: "Creación de páginas web, diseño gráfico, marketing digital, redes sociales y mucho más. Soluciones multimedia para empresas y emprendedores que quieren crecer en línea.",
      viewWork: "Ver Portafolio",
      capabilities: "Nuestros Servicios",
    },
    services: {
      title: "¿Qué te ofrecemos?",
      desc: "Brindamos soluciones digitales completas que se adaptan a cualquier tipo de negocio, desde emprendedores hasta grandes empresas.",
      web: "Creación de Páginas Web",
      webDesc: "Sitios web, landing pages y portales corporativos diseñados para convertir visitantes en clientes.",
      design: "Diseño Gráfico",
      designDesc: "Identidades corporativas, logotipos y branding que comunica el valor de tu marca.",
      marketing: "Marketing Digital",
      marketingDesc: "Publicidad en Google y Meta Ads, SEO y estrategias para que más personas encuentren tu negocio.",
      social: "Redes Sociales",
      socialDesc: "Gestión de contenido, estrategia y comunidades en Facebook, Instagram, WhatsApp Business y más.",
      ecommerce: "E-Commerce",
      ecommerceDesc: "Tiendas virtuales profesionales con catálogo, carrito de compras y pasarelas de pago integradas.",
      apps: "Aplicaciones",
      appsDesc: "Apps web y móviles a medida para optimizar procesos, gestionar clientes y digitalizar tu negocio.",
    },
    portfolioPreview: {
      title: "Proyectos Recientes",
      desc: "Algunos de los trabajos que hemos entregado con satisfacción garantizada.",
      viewCaseStudy: "Ver Proyecto",
      allProjects: "Ver Todos los Proyectos",
    },
    tech: {
      title: "Herramientas que dominamos",
      desc: "Trabajamos con las plataformas más importantes del ecosistema digital para maximizar los resultados de tu negocio.",
    },
    process: {
      title: "Nuestro Proceso",
      desc: "Transparente y orientado a resultados. Cada proyecto es tratado como propio.",
      step1: "Consulta Inicial",
      step1Desc: "Entendemos tus objetivos, audiencia y necesidades específicas para diseñar la mejor solución.",
      step2: "Propuesta y Diseño",
      step2Desc: "Creamos una propuesta personalizada con diseño preliminar y planificación del proyecto.",
      step3: "Desarrollo",
      step3Desc: "Construimos tu solución con atención al detalle, revisiones continuas y comunicación constante.",
      step4: "Lanzamiento",
      step4Desc: "Publicación, pruebas finales, capacitación y soporte posterior al lanzamiento incluido.",
    },
    pricing: {
      title: "Planes de Páginas Web",
      desc: "Precios claros y transparentes para proyectos de cualquier tamaño.",
      monthly: "Mensual",
      annual: "Anual",
      save: "Ahorras 2 meses",
      onepage: "Plan Onepage Express",
      onepageFeatures: [
        "Landing page optimizada",
        "Diseño responsivo y moderno",
        "Formulario de contacto",
        "Mapa y datos de contacto",
        "Hosting y dominio incluidos",
        "SEO básico",
      ],
      multipages: "Plan Multipáginas",
      multipagesDesc: "hasta 5 páginas",
      multipagesFeatures: [
        "Sitio corporativo completo",
        "Hasta 5 páginas internas",
        "SEO básico incluido",
        "Integración con Analytics",
        "Dashboard de gestión",
        "Correos empresariales",
        "Hosting y dominio incluidos",
      ],
      custom: "Plan Personalizado",
      customDesc: "Soluciones a medida para proyectos complejos",
      customFeatures: [
        "Tienda virtual completa (E-commerce)",
        "Diseño de identidad corporativa",
        "Estrategia de marketing digital",
        "Integración de APIs y sistemas",
        "Soporte y mantenimiento",
      ],
      contactQuote: "Solicitar Cotización",
      month: "/mes",
      year: " pago único",
      popular: "Recomendado",
      renewalNote: "Renovación anual: $245 USD",
      annualPaymentNote: "Pago único que incluye hosting y dominio por 1 año completo.",
      customPrice: "A Medida",
    },
    about: {
      title: "Nosotros",
      desc: "Somos un equipo entusiasta y dinámico con más de 15 años de experiencia impulsando negocios hacia el éxito digital.",
      missionTitle: "Nuestra Misión",
      missionDesc: "Impulsar a cada cliente hacia el éxito por medio de la web. Desarrollamos soluciones multimedia para empresas y personas físicas que inician su negocio en el mundo digital, con garantía de satisfacción y atención personalizada.",
      valuesTitle: "Nuestros Valores",
      values: [
        { title: "Compromiso", desc: "Nos importa cada proyecto como si fuera nuestro propio negocio." },
        { title: "Calidad", desc: "Más de 15 años garantizando resultados que superan las expectativas." },
        { title: "Adaptabilidad", desc: "Soluciones para todo tipo y tamaño de negocio, en cualquier industria." },
      ],
      whyChooseUs: "¿Por qué elegir MediaExperto?",
      whyChooseUsDesc: "A diferencia de las grandes agencias, trabajarás directamente con nuestro equipo. Con más de 15 años de experiencia y presencia en República Dominicana, conocemos el mercado local y tenemos alcance regional. Cada solución que diseñamos está pensada para impulsar resultados reales en tu negocio.",
      historyTitle: "Nuestra Historia",
      historyDesc: "Más de 15 años acompañando a empresas y emprendedores dominicanos en su camino hacia el éxito digital.",
      historyMilestones: [
        { year: "2009", text: "Fundación de MediaExperto con la misión de democratizar el acceso a soluciones digitales de calidad en República Dominicana." },
        { year: "2013", text: "Expansión de servicios: sumamos diseño audiovisual y marketing digital a nuestra oferta de desarrollo web." },
        { year: "2018", text: "Crecimiento del equipo y apertura de nuevos mercados en Latinoamérica." },
        { year: "2024", text: "Más de 15 años de experiencia, cientos de proyectos entregados y clientes satisfechos en múltiples industrias." },
      ],
      teamTitle: "Nuestro Equipo",
      teamDesc: "Personas entusiastas y dinámicas con deseos de dar lo mejor de sí para que tu negocio brille en línea.",
      teamPhoto1: "Foto del equipo 1",
      teamPhoto2: "Foto del equipo 2",
    },
    servicesPage: {
      title: "Nuestros Servicios",
      desc: "Soluciones multimedia completas para empresas y emprendedores que quieren crecer en el mundo digital.",
      whatsIncluded: "Qué incluye:",
      whoIsItFor: "Para quién es:",
      webFullDesc: "Diseñamos y desarrollamos sitios web, landing pages, portales corporativos con más de 15 años de experiencia. Cada proyecto es tratado como propio, orientado a convertir visitantes en clientes.",
      webFeatures: ["Diseño personalizado y responsivo", "Optimización SEO incluida", "Integración CMS (WordPress)", "Formularios y contacto directo", "Hosting y dominio incluidos"],
      designFullDesc: "Creamos identidades corporativas completas, logotipos, material publicitario y todo tipo de diseño gráfico y audiovisual para que tu marca comunique profesionalismo desde el primer vistazo.",
      designFeatures: ["Diseño de logotipos", "Identidad corporativa completa", "Material publicitario digital e impreso", "Diseño audiovisual y videos", "Presentaciones y branding"],
      marketingFullDesc: "Hacemos que más personas encuentren tu negocio en internet. Gestionamos campañas de publicidad en Google, Meta Ads y estrategias SEO orientadas a resultados medibles y concretos.",
      marketingFeatures: ["Publicidad en Google Ads", "Campañas en Meta (Facebook/Instagram)", "SEO y posicionamiento en buscadores", "Google Business Profile", "Analítica y reportes de resultados"],
      socialFullDesc: "Gestionamos tus redes sociales con contenido estratégico y atractivo para que tu comunidad crezca y tu audiencia se convierta en clientes reales.",
      socialFeatures: ["Gestión de Facebook e Instagram", "Creación de contenido visual", "WhatsApp Business", "Estrategia de contenidos", "Atención y gestión de comunidad"],
      ecommerceFullDesc: "Construimos tiendas virtuales profesionales con todo lo necesario para vender en línea: catálogo de productos, carrito de compras, pasarelas de pago y gestión de pedidos.",
      ecommerceFeatures: ["Tienda virtual completa", "Catálogo y gestión de productos", "Pasarelas de pago integradas", "Panel de administración", "Diseño orientado a conversión"],
      appsFullDesc: "Desarrollamos aplicaciones web y móviles a medida para optimizar los procesos de tu empresa, gestionar clientes, automatizar tareas y llevar tu negocio al siguiente nivel digital.",
      appsFeatures: ["Apps web a medida", "Aplicaciones móviles (iOS/Android)", "Sistemas de gestión internos", "Integración con APIs y servicios", "Soporte y mantenimiento incluido"],
    },
    portfolioPage: {
      title: "Portafolio",
      desc: "Explora algunos de nuestros proyectos entregados con satisfacción garantizada.",
      categories: {
        all: "Todos",
        landing: "Landing Page",
        webapp: "Aplicación Web",
        webpage: "Página Web",
        ecommerce: "E-Commerce",
        digitalinvitation: "Invitación Digital",
      },
    },
    contact: {
      title: "Contacto",
      desc: "Hablemos de cómo podemos impulsar tu negocio hacia el éxito digital.",
      infoTitle: "Información de Contacto",
      whatsappBannerTitle: "¿Tienes alguna pregunta o duda?",
      whatsappBannerDesc: "Escríbenos sin ningún compromiso — estaremos felices de responder todas tus preguntas y orientarte en tu proyecto.",
      whatsappBannerCta: "Escribir por WhatsApp",
      phoneLabel: "Teléfono / WhatsApp",
      thankYou: "¡Gracias!",
      sendAnother: "Enviar otro mensaje",
      form: {
        name: "Nombre Completo",
        email: "Correo Electrónico",
        phone: "Teléfono / WhatsApp",
        company: "Empresa (Opcional)",
        service: "Servicio de Interés",
        selectService: "Seleccione un servicio",
        serviceOptions: {
          web: "Desarrollo Web",
          design: "Diseño Gráfico",
          marketing: "Marketing Digital",
          social: "Redes Sociales",
          ecommerce: "E-Commerce",
          apps: "Aplicaciones Web / Móvil",
          other: "Otro",
        },
        message: "Mensaje o Detalles del Proyecto",
        submit: "Enviar Mensaje",
        success: "¡Mensaje enviado con éxito! Nos pondremos en contacto pronto.",
      },
      info: {
        email: "Email",
        phone: "Teléfono",
        address: "Dirección",
        social: "Redes Sociales",
      },
    },
    footer: {
      ctaTitle: "¿Listo para impulsar tu negocio",
      ctaTitleExtra: "al mundo digital?",
      ctaDesc: "Contamos con más de 15 años de experiencia diseñando soluciones para empresas y emprendedores. Hablemos de tu proyecto.",
      startConversation: "Iniciar Conversación",
      rights: "Todos los derechos reservados.",
    },
    socialPricing: {
      badge: "Manejo de Redes Sociales",
      title: "Planes de Redes Sociales",
      desc: "Gestiona tu presencia en Facebook e Instagram con un Community Manager dedicado a tu marca.",
      launchBanner: "Precio de oferta de lanzamiento — ¡Aprovecha ahora!",
      month: "/mes",
      regularPrice: "Precio regular:",
      cta: "Comenzar ahora",
      mostPopular: "Más Popular",
      bottomText: "¿No sabes qué plan es el correcto para tu negocio?",
      bottomLink: "Escríbenos y te orientamos",
      plans: [
        {
          id: "basico",
          name: "Plan Básico",
          launchPrice: "6,900",
          regularPrice: "9,500",
          highlight: false,
          tagline: "Ideal para pequeños negocios que desean comenzar a tener presencia en redes sociales.",
          features: [
            "8 publicaciones mensuales",
            "4 historias al mes",
            "Diseño gráfico profesional",
            "Calendario de contenido",
            "2 publicaciones semanales",
            "Gestión de Facebook e Instagram",
            "Reporte mensual básico",
          ],
        },
        {
          id: "profesional",
          name: "Plan Profesional",
          launchPrice: "11,900",
          regularPrice: "16,500",
          highlight: true,
          tagline: "Perfecto para negocios que desean crecer y mantener redes sociales activas y profesionales.",
          features: [
            "14 publicaciones mensuales",
            "10 historias al mes",
            "2 reels mensuales",
            "Diseño gráfico profesional",
            "Community Manager asignado",
            "Estrategia y planificación de contenido",
            "4 publicaciones semanales",
            "Gestión de Facebook e Instagram",
            "Respuesta básica a mensajes y comentarios",
            "Reporte mensual detallado",
          ],
        },
        {
          id: "premium",
          name: "Plan Premium",
          launchPrice: "19,900",
          regularPrice: "28,000",
          highlight: false,
          tagline: "Para marcas que buscan el máximo impacto y presencia profesional en redes.",
          features: [
            "22 publicaciones mensuales",
            "16 historias al mes",
            "4 reels mensuales",
            "Community Manager asignado",
            "Estrategia de contenido avanzada",
            "Diseño personalizado para campañas",
            "Gestión de promociones y concursos",
            "1 sesión básica de fotos o videos al mes",
            "Publicaciones frecuentes durante la semana",
            "Gestión de Facebook e Instagram",
            "Reporte mensual avanzado",
          ],
        },
      ],
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      services: "Services",
      portfolio: "Portfolio",
      pricing: "Pricing",
      contact: "Contact",
      startProject: "Start a Project",
    },
    hero: {
      title1: "We take your business",
      titleExtra: "to the digital world",
      title2: "with real results",
      desc: "Web development, graphic design, digital marketing, social media, and more. Multimedia solutions for businesses and entrepreneurs ready to grow online.",
      viewWork: "View Portfolio",
      capabilities: "Our Services",
    },
    services: {
      title: "What we offer?",
      desc: "We deliver complete digital solutions tailored to any type of business — from startups to established enterprises.",
      web: "Web Development",
      webDesc: "Websites, landing pages, and corporate portals designed to turn visitors into customers.",
      design: "Graphic Design",
      designDesc: "Corporate identities, logos, and branding that communicates your brand's value.",
      marketing: "Digital Marketing",
      marketingDesc: "Google and Meta Ads advertising, SEO, and strategies so more people can find your business.",
      social: "Social Media",
      socialDesc: "Content management, strategy, and community building on Facebook, Instagram, WhatsApp Business, and more.",
      ecommerce: "E-Commerce",
      ecommerceDesc: "Professional online stores with product catalog, shopping cart, and integrated payment gateways.",
      apps: "Applications",
      appsDesc: "Custom web and mobile apps to optimize processes, manage clients, and digitize your business.",
    },
    portfolioPreview: {
      title: "Recent Projects",
      desc: "A selection of work delivered with guaranteed satisfaction.",
      viewCaseStudy: "View Project",
      allProjects: "View All Projects",
    },
    tech: {
      title: "Tools we master",
      desc: "We work with the most important platforms in the digital ecosystem to maximize your business results.",
    },
    process: {
      title: "Our Process",
      desc: "Transparent and results-driven. Every project is treated as if it were our own.",
      step1: "Initial Consultation",
      step1Desc: "We understand your goals, audience, and specific needs to design the best solution.",
      step2: "Proposal & Design",
      step2Desc: "We create a personalized proposal with preliminary design and project planning.",
      step3: "Development",
      step3Desc: "We build your solution with attention to detail, continuous reviews, and constant communication.",
      step4: "Launch",
      step4Desc: "Publication, final testing, training, and post-launch support included.",
    },
    pricing: {
      title: "Website Pricing Plans",
      desc: "Clear and transparent pricing for projects of any size.",
      monthly: "Monthly",
      annual: "Annual",
      save: "Save 2 months",
      onepage: "Onepage Express Plan",
      onepageFeatures: [
        "Optimized landing page",
        "Responsive modern design",
        "Contact form",
        "Map and contact info",
        "Hosting and domain included",
        "Basic SEO",
      ],
      multipages: "Multi-page Plan",
      multipagesDesc: "up to 5 pages",
      multipagesFeatures: [
        "Complete corporate website",
        "Up to 5 internal pages",
        "Basic SEO included",
        "Analytics integration",
        "Management dashboard",
        "Business email accounts",
        "Hosting and domain included",
      ],
      custom: "Custom Plan",
      customDesc: "Tailored solutions for complex projects",
      customFeatures: [
        "Full e-commerce store",
        "Corporate identity design",
        "Digital marketing strategy",
        "API and system integration",
        "Support and maintenance",
      ],
      contactQuote: "Request a Quote",
      month: "/mo",
      year: " single payment",
      popular: "Recommended",
      renewalNote: "Annual renewal: $245 USD",
      annualPaymentNote: "Single payment includes hosting and domain for 1 full year.",
      customPrice: "Custom",
    },
    about: {
      title: "About Us",
      desc: "An enthusiastic and dynamic team with 15+ years of experience pushing businesses toward digital success.",
      missionTitle: "Our Mission",
      missionDesc: "To boost every client toward success through the web. We develop multimedia solutions for companies and individuals starting their digital journey, with a satisfaction guarantee and personalized attention.",
      valuesTitle: "Our Values",
      values: [
        { title: "Commitment", desc: "We care about every project as if it were our own business." },
        { title: "Quality", desc: "15+ years delivering results that exceed expectations." },
        { title: "Adaptability", desc: "Solutions for any type and size of business, in any industry." },
      ],
      whyChooseUs: "Why choose MediaExperto?",
      whyChooseUsDesc: "Unlike large agencies, you will work directly with our team. With over 15 years of experience and a presence in the Dominican Republic, we know the local market and have regional reach. Every solution we design is built to drive real results for your business.",
      historyTitle: "Our Story",
      historyDesc: "Over 15 years accompanying Dominican businesses and entrepreneurs on their path to digital success.",
      historyMilestones: [
        { year: "2009", text: "MediaExperto founded with the mission of democratizing access to quality digital solutions in the Dominican Republic." },
        { year: "2013", text: "Service expansion: we added audiovisual design and digital marketing to our web development offer." },
        { year: "2018", text: "Team growth and expansion into new Latin American markets." },
        { year: "2024", text: "15+ years of experience, hundreds of delivered projects, and satisfied clients across multiple industries." },
      ],
      teamTitle: "Our Team",
      teamDesc: "Enthusiastic and dynamic people committed to making your business shine online.",
      teamPhoto1: "Team photo 1",
      teamPhoto2: "Team photo 2",
    },
    servicesPage: {
      title: "Our Services",
      desc: "Complete multimedia solutions for businesses and entrepreneurs ready to grow in the digital world.",
      whatsIncluded: "What's included:",
      whoIsItFor: "Who is it for:",
      webFullDesc: "We design and develop websites, landing pages, and corporate portals with 15+ years of experience. Every project is treated as our own, focused on turning visitors into customers.",
      webFeatures: ["Custom & responsive design", "SEO optimization included", "CMS integration (WordPress)", "Contact forms & direct contact", "Hosting and domain included"],
      designFullDesc: "We create complete corporate identities, logos, advertising materials, and all types of graphic and audiovisual design so your brand communicates professionalism from the first glance.",
      designFeatures: ["Logo design", "Complete corporate identity", "Digital and print advertising materials", "Audiovisual design and videos", "Presentations and branding"],
      marketingFullDesc: "We help more people find your business online. We manage advertising campaigns on Google, Meta Ads, and SEO strategies focused on measurable and concrete results.",
      marketingFeatures: ["Google Ads advertising", "Meta campaigns (Facebook/Instagram)", "SEO and search engine ranking", "Google Business Profile", "Analytics and performance reports"],
      socialFullDesc: "We manage your social media with strategic and engaging content so your community grows and your audience turns into real customers.",
      socialFeatures: ["Facebook & Instagram management", "Visual content creation", "WhatsApp Business", "Content strategy", "Community management"],
      ecommerceFullDesc: "We build professional online stores with everything needed to sell online: product catalog, shopping cart, payment gateways, and order management.",
      ecommerceFeatures: ["Complete online store", "Product catalog & management", "Integrated payment gateways", "Admin dashboard", "Conversion-focused design"],
      appsFullDesc: "We develop custom web and mobile applications to optimize your business processes, manage clients, automate tasks, and take your business to the next digital level.",
      appsFeatures: ["Custom web apps", "Mobile applications (iOS/Android)", "Internal management systems", "API and service integrations", "Support and maintenance included"],
    },
    portfolioPage: {
      title: "Portfolio",
      desc: "Explore some of our projects delivered with guaranteed satisfaction.",
      categories: {
        all: "All",
        landing: "Landing Page",
        webapp: "Web App",
        webpage: "Web Page",
        ecommerce: "E-Commerce",
        digitalinvitation: "Digital Invitation",
      },
    },
    contact: {
      title: "Contact",
      desc: "Let's talk about how we can take your business to the digital world.",
      infoTitle: "Contact Information",
      whatsappBannerTitle: "Do you have a question?",
      whatsappBannerDesc: "Write to us without any commitment — we'll be happy to answer all your questions and guide you on your project.",
      whatsappBannerCta: "Write on WhatsApp",
      phoneLabel: "Phone / WhatsApp",
      thankYou: "Thank you!",
      sendAnother: "Send another message",
      form: {
        name: "Full Name",
        email: "Email Address",
        phone: "Phone / WhatsApp",
        company: "Company (Optional)",
        service: "Service of Interest",
        selectService: "Select a service",
        serviceOptions: {
          web: "Web Development",
          design: "Graphic Design",
          marketing: "Digital Marketing",
          social: "Social Media",
          ecommerce: "E-Commerce",
          apps: "Web / Mobile Applications",
          other: "Other",
        },
        message: "Message or Project Details",
        submit: "Send Message",
        success: "Message sent successfully! We will contact you soon.",
      },
      info: {
        email: "Email",
        phone: "Phone",
        address: "Address",
        social: "Social Media",
      },
    },
    footer: {
      ctaTitle: "Ready to take your business",
      ctaTitleExtra: "to the digital world?",
      ctaDesc: "With 15+ years of experience designing solutions for businesses and entrepreneurs, we're ready for your project.",
      startConversation: "Start the Conversation",
      rights: "All rights reserved.",
    },
    socialPricing: {
      badge: "Social Media Management",
      title: "Social Media Plans",
      desc: "Manage your Facebook and Instagram presence with a Community Manager dedicated to your brand.",
      launchBanner: "Launch offer price — Take advantage now!",
      month: "/mo",
      regularPrice: "Regular price:",
      cta: "Get started",
      mostPopular: "Most Popular",
      bottomText: "Not sure which plan is right for your business?",
      bottomLink: "Write to us and we'll guide you",
      plans: [
        {
          id: "basico",
          name: "Basic Plan",
          launchPrice: "6,900",
          regularPrice: "9,500",
          highlight: false,
          tagline: "Ideal for small businesses looking to start building their social media presence.",
          features: [
            "8 monthly posts",
            "4 stories per month",
            "Professional graphic design",
            "Content calendar",
            "2 posts per week",
            "Facebook & Instagram management",
            "Basic monthly report",
          ],
        },
        {
          id: "profesional",
          name: "Professional Plan",
          launchPrice: "11,900",
          regularPrice: "16,500",
          highlight: true,
          tagline: "Perfect for businesses looking to grow and maintain active and professional social media.",
          features: [
            "14 monthly posts",
            "10 stories per month",
            "2 monthly reels",
            "Professional graphic design",
            "Assigned Community Manager",
            "Content strategy & planning",
            "4 posts per week",
            "Facebook & Instagram management",
            "Basic response to messages & comments",
            "Detailed monthly report",
          ],
        },
        {
          id: "premium",
          name: "Premium Plan",
          launchPrice: "19,900",
          regularPrice: "28,000",
          highlight: false,
          tagline: "For brands seeking maximum impact and a professional presence on social media.",
          features: [
            "22 monthly posts",
            "16 stories per month",
            "4 monthly reels",
            "Assigned Community Manager",
            "Advanced content strategy",
            "Custom design for campaigns",
            "Promotions & contests management",
            "1 basic photo/video session per month",
            "Frequent posts throughout the week",
            "Facebook & Instagram management",
            "Advanced monthly report",
          ],
        },
      ],
    },
  },
};
